import React from 'react';

const amplify = {

    dev: {
        Auth:{
          "identityPoolId": 'us-west-2:def6b698-857f-41a7-84f4-0c3665a3466d',
          "region": "us-west-2",
          "userPoolId": 'us-west-2_QUgfop81d',
          "userPoolWebClientId": '4qsmigoa0o19uq5jegfdl4f9ne',
        
          "oauth": {
            "domain":  "emitir-notas-test.auth.us-west-2.amazoncognito.com",
            "scope":["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
            "redirectSignIn": "http://localhost:3000",
            "redirectSignOut": "http://localhost:3000",
            "responseType": "code"
          }
        }
    },
    test: {
        Auth:{
          "identityPoolId": 'us-west-2:def6b698-857f-41a7-84f4-0c3665a3466d',
          "region": "us-west-2",
          "userPoolId": 'us-west-2_QUgfop81d',
          "userPoolWebClientId": '4qsmigoa0o19uq5jegfdl4f9ne',
        
          "oauth": {
            "domain":  "emitir-notas-test.auth.us-west-2.amazoncognito.com",
            "scope":["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
            "redirectSignIn": "https://apptest.contentsys.com.br",
            "redirectSignOut": "https://apptest.contentsys.com.br",
            "responseType": "code"
          }
        }
    },
    prod: {
      Auth:{
        "identityPoolId": 'us-west-2:bb59db08-e501-44be-806e-ce61bcf344f8',
        "region": "us-west-2",
        "userPoolId": 'us-west-2_uItIn6oMc',
        "userPoolWebClientId": '73bjfqq6v0bgel7u56h2efo5nj',
      
        "oauth": {
          "domain":  "contentsys.auth.us-west-2.amazoncognito.com",
          "scope":["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
          "redirectSignIn": "https://devolucao.contentsys.com.br",
          "redirectSignOut": "https://devolucao.contentsys.com.br",
          "responseType": "code"
        }
      }
  }
      
}

const reactAppEnv = process.env.REACT_APP_ENV;

const amplifyContext = React.createContext(amplify[reactAppEnv]);

export {amplifyContext};
